import { CartogramStore } from '@project/store/Cartogram';
import { createContext, useContext } from 'react';

const CartogramStoreContext = createContext<CartogramStore | null>(null);

export const useCartogramStore = () => {
  const context = useContext(CartogramStoreContext);
  if (!context) {
    throw new Error('CartogramStore not provided');
  }

  return context;
};

export const CartogramStoreProvider = CartogramStoreContext.Provider;
